import apiClient from "../../../services/apiClient";

export const approveRequestsReqAPI = {
  cancel: async (id: string, data: any): Promise<void> => {
    const response = await apiClient.patch(`/api/petition/anulled/${id}`, data);

    return response.data;
  },
};
